/**
 * ForbiddenReasonPanel — 403 surface without role/capability topology (U4/U2 · S5)
 * 상태 표시 + 안전한 구조적 링크만. telling 산문 금지.
 */

import React from 'react';
import { Button, Result } from 'antd';

export interface ForbiddenReasonPanelLink {
  label: string;
  href: string;
  primary?: boolean;
}

export interface ForbiddenReasonPanelProps {
  title?: string;
  message?: string;
  links?: ForbiddenReasonPanelLink[];
  onNavigate?: (href: string) => void;
  'data-testid'?: string;
}

const DEFAULT_MESSAGE = '이 경로에 대한 접근 권한이 없습니다.';

export const ForbiddenReasonPanel: React.FC<ForbiddenReasonPanelProps> = ({
  title = '403',
  message = DEFAULT_MESSAGE,
  links = [],
  onNavigate,
  'data-testid': testId = 'forbidden-reason-panel',
}) => {
  const extra =
    links.length > 0 && onNavigate ? (
      <>
        {links.map((link) => (
          <Button
            key={link.href}
            type={link.primary ? 'primary' : 'default'}
            onClick={() => onNavigate(link.href)}
          >
            {link.label}
          </Button>
        ))}
      </>
    ) : undefined;

  return (
    <div data-testid={testId}>
      <Result status="403" title={title} subTitle={message} extra={extra} />
    </div>
  );
};

export default ForbiddenReasonPanel;
